interface CustomEventOptions {
  bubbles?: boolean
  cancelable?: boolean
  detail: any
}

export default function (eventName: string, options?: CustomEventOptions) {
  const event = new CustomEvent(eventName, {
    bubbles: true,
    cancelable: true,
    ...options,
  })
  document.dispatchEvent(event)
}
